import { useQuery } from '@tanstack/vue-query'
import { apiClient } from '@/apis/instances/api-client'
import { checkApiResponse } from '@/apis/instances/check-api-response'
import { ApiReservationsheetElFindParams } from '@/apis/swaggers/v2/v2-swagger'
import { QUERY_KEY } from '@/apis/swaggers/swagger-docs'
import { QueryComposableParams } from '@/types/query-options'
import { resolveMaybeGetter } from '@/util/resolve-maybe-getter'

type QueryParams = QueryComposableParams<ApiReservationsheetElFindParams, unknown>

const fetchReservationSheetList = async (params: ApiReservationsheetElFindParams) => {
  const { data } = await apiClient.v2.apiReservationsheetElFind(params);
  return checkApiResponse(data);
}

export const reservationSheetKeys = {
  all: [QUERY_KEY.v2apiReservationsheetElFind] as const,
  list: (params: ApiReservationsheetElFindParams) => [...reservationSheetKeys.all, params] as const,
}

/** 명령형(await) 호출용 쿼리 정의 — `queryClient.fetchQuery(reservationSheetFindQueryOptions(params))` */
export const reservationSheetFindQueryOptions = (params: ApiReservationsheetElFindParams) => ({
  queryKey: reservationSheetKeys.list(params),
  queryFn: () => fetchReservationSheetList(params),
})

export const useReservationSheetFindQuery = ({ params, options }: QueryParams) => {
  return useQuery(() => ({
    queryKey: reservationSheetKeys.list(resolveMaybeGetter(params)),
    queryFn: () => fetchReservationSheetList(resolveMaybeGetter(params)),
    ...resolveMaybeGetter(options ?? {}),
  }))
}
